import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { ErrorBanner } from 'ui/banner';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { closeModal } from '../../../ducks';
import { ALIGN_NODES_MODAL } from '../../../constants';

export const ALIGN_NODES_BUTTON_TEST_ID = 'align-nodes-button';
export const ALIGN_NODES_ERROR_BANNER_TEST_ID = 'align-nodes-error-banner';

type AlignNodesErrorBannerProps = {
  showErrorBanner: boolean;
};

const AlignNodesErrorBanner = ({ showErrorBanner }: AlignNodesErrorBannerProps) => (
  /* We have to wrap this so that onClose prop is not provided by the Modal  */
  <div>
    {showErrorBanner && (
      <ErrorBanner data-test={ALIGN_NODES_ERROR_BANNER_TEST_ID}>
        Sorry, something went wrong. Try aligning the tiles again.
      </ErrorBanner>
    )}
  </div>
);

type Props = {
  /** Whether the modal is open */
  isOpen: boolean;
  alignNodes: () => void;
};

export const AlignNodesModal = ({ isOpen, alignNodes }: Props) => {
  const [showErrorBanner, setShowErrorBanner] = useState(false);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal(ALIGN_NODES_MODAL));
  };
  const handleSubmit = () => {
    try {
      setShowErrorBanner(false);
      alignNodes();
      handleCloseModal();
    } catch (e) {
      setShowErrorBanner(true);
    }
  };
  return (
    <Modal
      id={ALIGN_NODES_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Align tiles?</ModalHeader>
      <AlignNodesErrorBanner {...{ showErrorBanner }} />
      <ModalBody>
        The connected tiles within this journey will be moved and realigned to a grid. This does not
        affect any connections made between the tiles.
      </ModalBody>
      <ModalFooter cancelLabel={'Cancel'}>
        <Button
          autoFocus
          data-test={ALIGN_NODES_BUTTON_TEST_ID}
          onClick={handleSubmit}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          Align tiles
        </Button>
      </ModalFooter>
    </Modal>
  );
};
